const press = [
    { 'press': 'CDM: Mayss "On this Land"', 'link': 'https://cdm.link/mayss-on-this-land/' },
    { 'press': 'DJ Mag', 'link': 'https://djmag.com/news/nicolas-jaar-simo-cell-kmru-juliana-huxtable-more-contribute-62-track-compilation-gaza' },
    { 'press': 'The Quietus', 'link': 'https://thequietus.com/news/martin-rev-suzanne-ciani-and-more-contribute-music-to-compilation-for-palestine/' },
    { 'press': 'Electronic Groove', 'link': 'https://electronicgroove.com/nicolas-jaar-kmru-unite-compilation-for-palestinian-children/' },
    { 'press': 'CDM: Enough! comp', 'link': 'https://cdm.link/enough-compilation-call-to-sound-from-dr-ghassan/' }
];

export default press;
